var _defs, _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _path, _path2, _path3, _line5, _text, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _text2, _text3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChartSwHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "swh-bg",
    cx: 84,
    cy: 52,
    r: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6F8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDF0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "swh-water",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32d1c8",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#32d1c8",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "swh-grid",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 0.65,
    fill: "#C7D1CC",
    opacity: 0.45
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 200,
    rx: 14,
    fill: "url(#swh-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 24,
    width: 232,
    height: 150,
    fill: "url(#swh-grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 140,
    width: 232,
    height: 34,
    fill: "url(#swh-water)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 24,
    x2: 98,
    y2: 174,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 156,
    y1: 24,
    x2: 156,
    y2: 174,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 214,
    y1: 24,
    x2: 214,
    y2: 174,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 24,
    x2: 72,
    y2: 174,
    stroke: "#C7D1CC",
    strokeWidth: 0.75,
    strokeDasharray: "3 3",
    opacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 78 30 C 80 58 84 76 92 100 C 101 124 130 137 264 140",
    stroke: "#32d1c8",
    strokeWidth: 7,
    strokeOpacity: 0.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 78 30 C 80 58 84 76 92 100 C 101 124 130 137 264 140",
    stroke: "#32d1c8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 83 32 L 79 44 L 86 57 L 81 70 L 90 84 L 86 98 L 99 112 L 95 124 L 116 133 L 150 137 L 200 139 L 258 141",
    stroke: "#7C8FA5",
    strokeWidth: 1.25,
    strokeDasharray: "4 3",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 140,
    x2: 272,
    y2: 140,
    stroke: "#32d1c8",
    strokeWidth: 1.25,
    strokeDasharray: "5 4",
    opacity: 0.85
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 268,
    y: 134,
    textAnchor: "end",
    fontSize: 8.5,
    fontFamily: "system-ui, sans-serif",
    fill: "#5FB8B2"
  }, "FWL")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 272,
    y2: 24,
    stroke: "#A7B7AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 40,
    y2: 174,
    stroke: "#A7B7AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 19,
    x2: 98,
    y2: 24,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 156,
    y1: 19,
    x2: 156,
    y2: 24,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 214,
    y1: 19,
    x2: 214,
    y2: 24,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 62,
    x2: 40,
    y2: 62,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 100,
    x2: 40,
    y2: 100,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 140,
    x2: 40,
    y2: 140,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 47,
    r: 8,
    fill: "#32d1c8",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 47,
    r: 3.5,
    fill: "#32d1c8",
    fillOpacity: 0.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 47,
    r: 2,
    fill: "#32d1c8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 82,
    r: 8,
    fill: "#32d1c8",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 82,
    r: 3.5,
    fill: "#32d1c8",
    fillOpacity: 0.45
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 82,
    r: 2,
    fill: "#32d1c8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 109,
    r: 8,
    fill: "#32d1c8",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 109,
    r: 3.5,
    fill: "#32d1c8",
    fillOpacity: 0.45
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 109,
    r: 2,
    fill: "#32d1c8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 130,
    r: 8,
    fill: "#32d1c8",
    fillOpacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 130,
    r: 3.5,
    fill: "#32d1c8",
    fillOpacity: 0.45
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 130,
    r: 2,
    fill: "#32d1c8"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 152,
    r: 8,
    fill: "#32d1c8",
    fillOpacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 152,
    r: 3.5,
    fill: "#32d1c8",
    fillOpacity: 0.45
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 152,
    r: 2,
    fill: "#32d1c8"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 156,
    y: 14,
    textAnchor: "middle",
    fontSize: 10,
    fontFamily: "system-ui, sans-serif",
    fill: "#A7B7AF"
  }, "Sw")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 99,
    textAnchor: "middle",
    fontSize: 10,
    fontFamily: "system-ui, sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90, 18, 99)"
  }, "Depth")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChartSwHeight);
export default __webpack_public_path__ + "static/media/empty-chart-sw-height.ceb55deafc7e9ce92e3cf11c3f926c80.svg";
export { ForwardRef as ReactComponent };